// src/context/ThemeContext.jsx
//
// ╔════════════════════════════════════════════════════════════╗
// ║  STATISCHER THEME-KONTEXT                                  ║
// ║  Kein Switcher, keine localStorage-Logik.                  ║
// ║  Alle Design-Werte → index.css (:root)                     ║
// ╚════════════════════════════════════════════════════════════╝

import React, { createContext, useContext } from 'react';

const ThemeContext = createContext(null);

// ── Feste Werte ──────────────────────────────────────────────
// Hier kannst du features an/abschalten ohne den ThemeSwitcher.
// Diese Werte werden von Navbar, HeroSection usw. per useTheme() gelesen.

const STATIC_THEME = {
  colors: {
    primary:    { 500: '#7a7c5e', 600: '#62644b' },
    secondary:  { 500: '#5f8689', 600: '#4c6b6e' },
    accent:     { 500: '#d47e52', 600: '#b66642' },
    background: {
      primary:   '#fbfbfa',
      secondary: '#f5f0eb',
      tertiary:  '#ede8e2',
    },
    text: {
      primary:   '#1a1b12',
      secondary: '#3e4030',
      muted:     '#6e7056',
      inverse:   '#ffffff',
    },
  },
};

// ── Feature-Flags ─────────────────────────────────────────────
// true / false – kein UI nötig, einfach hier ändern
const STATIC_FEATURES = {
  animations:      true,   // Framer-Motion-Übergänge
  organicShapes:   false,  // runde Bio-Formen bei Bild-Containern
  gradients:       false,  // Hintergrund-Gradient in HeroSection
  parallax:        false,  // Scroll-Parallax in HeroSection
  autoHideNavbar:  false,  // Navbar beim Scrollen verstecken
  smoothScroll:    true,   // sanftes Scrollen bei Links
};

// ─────────────────────────────────────────────────────────────

export const ThemeProvider = ({ children }) => {
  const value = {
    // Theme-Objekt (für Komponenten die theme.colors.* lesen)
    theme: STATIC_THEME,

    // Features
    features: STATIC_FEATURES,

    // Legacy-Felder die manche Komponenten noch abfragen
    isDark: false,
    themeName: 'sage',
    styleName: 'organic',

    // No-op Aktionen (ThemeSwitcher ist entfernt, aber falls noch irgendwo
    // aufgerufen wird bricht nichts)
    setPalette:         () => {},
    setSurface:         () => {},
    setAccent:          () => {},
    toggleMode:         () => {},
    setButtonVariant:   () => {},
    setCardVariant:     () => {},
    applyPreset:        () => {},
    resetConfig:        () => {},
    exportConfig:       () => '{}',
    importConfig:       () => ({ ok: false }),
    toggleFeature:      () => {},
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useThemeContext = () => {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme muss innerhalb eines ThemeProvider verwendet werden');
  return ctx;
};

export default ThemeContext;